import { examQuestions } from "../fragments/exam";
import { alignments, examContent, tags } from "../fragments/resource";

export {
  getExamConfigQuery,
  getExamConfigQueryLegacy,
  getExamConfigQueryLegacy2,
} from "./examConfig";

export const archiveCampfireUserActivities = /* GraphQL */ `
  mutation ArchiveCampfireUserActivities($input: ControllerInput!) {
    archiveCampfireUserActivities(input: $input)
  }
`;

export const deleteClassroomActivityAction = /* GraphQL */ `
  mutation DeleteClassroomActivity($input: ControllerInput!) {
    deleteClassroomActivityAction(input: $input) {
      id
      sk
    }
  }
`;

export const archiveExam = /* GraphQL */ `
  mutation ArchiveExam(
    $input: IDSKInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    archiveExam(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
    }
  }
`;

export const getExamQuery = /* GraphQL */ `
  query GetExam($input: ModelGetInput!) {
    getResource(input: $input) {
      id
      sk
      workspaceId
      schemaVersion
      visibility
      idInc
      name
      questionIds
      subject
      grade
      maturity
      language
      creatorId
      isUnlisted
      workspace {
        id
        name
      }
      ${tags}
      ${alignments}
    }
  }
`;

export const getPlayableExamQuery = /* GraphQL */ `
  query GetPlayableExam($input: ModelGetInput!) {
    getPlayableExam(input: $input) {
      id
      sk
      workspaceId
      schemaVersion
      visibility
      idInc
      name
      questionIds
      subject
      grade
      maturity
      language
      creatorId
      isUnlisted
      workspace {
        id
        name
      }
      config
      ${tags}
      ${examContent}
      ${examQuestions}
      ${alignments}
    }
  }
`;

export const getPlayableExamWithoutScoringQuery = /* GraphQL */ `
  query GetPlayableExam($input: ModelGetInput!) {
    getPlayableExam(input: $input) {
      id
      sk
      workspaceId
      schemaVersion
      visibility
      idInc
      name
      questionIds
      subject
      tags {
        key
        type
        value
      }
      content {
        forms {
          sections {
            name
            questionIds
          }
        }
      }
      config
      questions {
        id
        sk
        workspaceId
        bankId
        idInc
        name
        fontScaling
        content {
          canvas {
            id
            type
            interactionType
            content
            config
          }
        }
        contexts {
          items {
            id
            sk
            name
            type
            content {
              body
            }
          }
        }
      }
    }
  }
`;

export const getPrintableExamQuery = /* GraphQL */ `
  query GetPrintableExam($input: ModelGetInput!) {
    getPrintableExam(input: $input) {
      id
      idInc
      name
      questionIds
      ${examContent}
      ${tags}
      ${examQuestions}
    }
  }
`;

export const getExamTicketQuery = /* GraphQL */ `
  query GetExamTicket($input: ModelGetInput!) {
    getExamTicket(input: $input) {
      id
      sk
      bankId
      idInc
      idVendor
      name
      resourceId
      resource {
        id
        sk
        name
        config
        resourceId
        workspaceId
        resource {
          id
          sk
          name
          questionIds
          workspaceId
          questions {
            id
            sk
            name
            fontScaling
            content {
              canvas {
                id
                type
                interactionType
                content
                config
              }
            }
            contexts {
              items {
                id
                sk
                name
                type
                content {
                  body
                }
              }
            }
          }
          content {
            forms {
              name
              type
              config
              sections {
                name
                type
                config
                questionIds
              }
            }
          }
        }
        tags {
          key
          type
          value
        }
      }
      schemaVersion
      tags {
        key
        type
        value
      }
      type
      version
      workspaceId
    }
  }
`;

export const getExamItems = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      name
      description
      createdAt
      grade
      questions {
        id
        sk
        name
        idInc
        maturity
        fontScaling
        content {
          canvas {
            content
            scoring
            config
          }
        }
      }
      content {
        forms {
          sections {
            questionIds
          }
        }
      }
    }
  }
`;

/**
 * @todo Trying to transition away from queries in
 * `apps/cms/src/graphql/custom/queries.js` that are being shared across all
 * sorts of editors, and therefore are difficult to change and know what will
 * get affected. We should ultimately have a single query responsible for each
 * editor.
 */
export const getExamEditorData = /* GraphQL */ ``;

export const getObjectivesForExam = /* GraphQL */ `
  query GetExamObjectives($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      name
      questions {
        id
        sk
        name
        alignments {
          items {
            id
            outlineNumber
            abbreviation
            content
            scope
          }
        }
      }
    }
  }
`;

export const getContextsForExam = /* GraphQL */ `
  query GetExamContexts($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      name
      questions {
        id
        sk
        name
        contexts {
          items {
            id
            sk
            name
            maturity
          }
        }
      }
    }
  }
`;
